import React from "react";
import {
    CssBaseline,
    Container,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core";
import {isMobile, useI18N} from "../../../common/common";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import PropTypes from "prop-types";
import clsx from "clsx";
import {CustomButton, CloseIcon} from "@hapinest/theme";
import NoIndexDialog from "../noIndex/NoIndexDialog";
import {useAnalytics} from "../../../store/providers/AnalyticsProvider";

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(7),
        marginBottom: theme.spacing(5),
        marginLeft: theme.spacing(7),
        textAlign: "center"
    },
    root: {
        width: "100%",
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    stepWrap: {
        padding: 0
    },
    iconBtn: {
        position: "absolute",
        right: theme.spacing(2)
    },
    step: {
        color: theme.palette.grey[500] + "!important",
        width: 24
    },
    stepLabel: {
        fontWeight: 600,
        fontSize: 16,
        fill: theme.palette.grey[0],
    },
    flexCenter: {
        display: "flex",
        justifyContent: "center"
    },
    content: {
        color: theme.palette.grey[900]
    },
    btnOkay: {
        padding: "18px 32px",
        borderRadius: theme.spacing(0.5)
    },
    section: {
        marginBottom: theme.spacing(5)
    },
    titleWrap: {
        display: "flex",
        justifyContent: "center"
    }
}));

export function InfoStepperDialog({open, onCloseTip, collection, title, buttonText, onButtonClick, buyersOfferDetails, event}) {
    const isMobileDevice = isMobile();

    const classes = useStyles();
    const {i18n} = useI18N();
    const { sendCustomEvent } = useAnalytics();

    const handleClose = () => {
        onCloseTip(false);
    };

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
            if (sendCustomEvent && buyersOfferDetails) {
                sendCustomEvent(event);
            }
        }
    };

    return (
        <NoIndexDialog
            onBackdropClick={handleClose}
            open={open}
            maxWidth={"sm"}
            fullScreen={isMobileDevice}
            fullWidth
        >
            <DialogTitle>
                <Grid
                    container
                    alignItems="center"
                    spacing={0}
                >
                    <Grid
                        item
                        md={12}
                        xs={12}
                        sm={12}
                        align={"right"}
                        className={classes.titleWrap}
                    >

                        <Typography
                            variant="h4"
                            className={classes.title}
                        >
                            {title}
                        </Typography>

                        <IconButton
                            aria-label="close"
                            className={classes.iconBtn}
                            onClick={handleClose}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <Container component="main">
                <CssBaseline />

                <section className={classes.section}>
                    <div className={classes.root}>
                        <Stepper
                            orientation="vertical"
                            className={classes.stepWrap}
                        >
                            {/* eslint-disable-next-line react/prop-types */}
                            {collection?.howToStepsCollection?.items?.map(({headline, explanation}) => (
                                <Step
                                    active
                                    key={headline}
                                >
                                    <StepLabel
                                        StepIconProps={{
                                            classes: {
                                                root: classes.step,
                                                text: classes.stepLabel
                                            }
                                        }}
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            color="textPrimary"
                                        >
                                            {headline}
                                        </Typography>
                                    </StepLabel>

                                    <StepContent>
                                        <Typography
                                            variant="body2"
                                            className={classes.content}
                                        >
                                            {explanation}
                                        </Typography>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                </section>

                <div className={classes.flexCenter}>
                    <CustomButton
                        variant={"contained"}
                        disableElevation
                        onClick={handleButtonClick}
                        size={"medium"}
                        className={clsx(classes.title, classes.btnOkay)}
                        e2e-id="info-stepper-continue-btn"
                    >
                        {
                            // eslint-disable-next-line react/prop-types
                            buttonText ? buttonText : (collection?.indentifier === "sell" ? i18n("dialog.no_rights_sell_shares.lets_start") : i18n("dialog.no_rights_sell_shares.ok_thank_you"))
                        }
                    </CustomButton>
                </div>
            </Container>
        </NoIndexDialog>
    );
}

InfoStepperDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    collection: PropTypes.shape({
        headline: PropTypes.string,
        explanation: PropTypes.string
    }),
    title: PropTypes.string.isRequired,
    onCloseTip: PropTypes.func,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
    buyersOfferDetails: PropTypes.any,
    event: PropTypes.object
};
